/* eslint import/no-extraneous-dependencies: off*/
// import history from '@history';
import { createSlice } from '@reduxjs/toolkit';
import _ from '@lodash';
import { setInitialSettings, setDefaultSettings } from 'app/store/fuse/settingsSlice';

export const setUserData = user => async (dispatch, getState) => {
  dispatch(setDefaultSettings(user.data.settings));

  // dispatch(setUser(user));
};

export const updateUserSettings = settings => async (dispatch, getState) => {
  const oldUser = getState().auth.user;
  const user = _.merge({}, oldUser, { data: { settings } });
  dispatch(updateUserData(user));
  return dispatch(setUserData(user));
};

export const updateUserShortcuts = shortcuts => async (dispatch, getState) => {
  const { user } = getState().auth;
  const newUser = {
    ...user,
    data: {
      ...user.data,
      shortcuts
    }
  };

  dispatch(updateUserData(user));

  return dispatch(setUserData(newUser));
};

export const logoutUser = () => async (dispatch, getState) => {
  dispatch(setInitialSettings());
  return dispatch(userLoggedOut());
};

export const updateUserData = user => async (dispatch, getState) => {};

const initialState = {
  error: '',
  success: '',
  data: {
    /* defaults */
    id: '',
    name: 'Ad',
    surname: 'Soyad',
    title: 'CRM Admin',
    tckn: '',
    birthdate: '',
    telephone: '',
    email: '',
    photo_url: null,
    role_id: ''
  },
  roles: []
};

const userSlice = createSlice({
  name: 'auth/user',
  initialState,
  reducers: {
    setUser: (state, action) => {
      state.data = action.payload;
    },
    setUserRoles: (state, action) => {
      state.roles = action.payload;
    },
    updateUserProfile: (state, action) => {
      return {
        ...state,
        data: {
          ...state.data,
          ...action.payload
        }
      };
    },
    userLoggedOut: (state, action) => initialState
  },
  extraReducers: {}
});

export const { setUser, setUserRoles, updateUserProfile, userLoggedOut } = userSlice.actions;

export default userSlice.reducer;
